import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import HomeV1 from "./components/home-v1";
import About from "./components/about";
import Faq from "./components/faq";
import Shop from "./components/shop";
import ProductDetails from "./components/product-details";
import BlogGrid from "./components/blog-grid";
import BlogDetails from "./components/blog-details";
import Contact from "./components/contact";
import SaleService from "./components/sale-service";
import InvestorRelations from "./components/investor-relations";
import AppDataProvider from "./app/AppDataProvider";
import ComingSoon from "./components/coming-soon";
import Error from "./components/404";
import QrRedirect from "./components/qr-redirect";

import GlobalLoaderController from "./components/GlobalLoaderController";
import Popup from "./components/global-components/Popup";

class Website extends Component {
  render() {
    return (
      <AppDataProvider>
        <GlobalLoaderController />
        <Popup />
        <div>
          <Switch>
            <Route exact path="/" component={HomeV1} />
            <Route path="/kurumsal" component={About} />
            <Route path="/sikca-sorulanlar-ve-bilgiler" component={Faq} />
            <Route exact path="/urunler" component={Shop} />
            <Route path="/urunler/:slug" component={ProductDetails} />
            <Route exact path="/haberler" component={BlogGrid} />
            <Route path="/haber/:slug" component={BlogDetails} />
            <Route path="/iletisim" component={Contact} />
            <Route path="/satis-servis" component={SaleService} />
            <Route
              path="/yatirimci-iliskileri"
              component={InvestorRelations}
            />
            <Route path="/404" component={Error} />
            {/* <Route path="/bakim" component={ComingSoon} /> */}
            {/* --- UNKNOWN ROUTES CATCHER --- */}
            <Route component={Error} />
          </Switch>
        </div>
      </AppDataProvider>
    );
  }
}

const Root = () => (
  <Router basename="/">
    <Switch>
      <Route exact path="/qr/:slug" component={QrRedirect} />
      <Route component={Website} />
    </Switch>
  </Router>
);

export default Root;

ReactDOM.render(<Root />, document.getElementById("quarter"));
